/* Other */
import { EPG_VALUES } from '../../utils/constants';
import { normalizeRowAdApiCategory } from './rowAdCategoryNormalize';

const ROW_AD_CATEGORY_ALL = 'all';
const ROW_AD_CATEGORY_EVERY = 'every_categories';
const ROW_AD_CATEGORY_SPORTS = 'sports';

/**
 * Converte o filtro da EPG para o slug `category` da API (row ads).
 * @param {string|undefined} filterValue
 * @returns {string|null} slug canónico ou null para tab "Todos"
 */
export function mapEpgFilterValueToRowAdApiCategory(filterValue) {
  if (filterValue == null || filterValue === EPG_VALUES.all) {
    return null;
  }
  return normalizeRowAdApiCategory(filterValue);
}

function norm(c) {
  return String(c || '').trim().toLowerCase();
}

/**
 * Tab "Todos" no `getEpgFilters`: `value` vem como `undefined` (EPG_CONFIG_MAPPING sobrescreve).
 * Sem isto, cai-se em `every_categories` em vez de `category: all`.
 */
function isAllFilterTab(selectedFilterValue) {
  return selectedFilterValue == null || selectedFilterValue === EPG_VALUES.all;
}

function sortByPosition(models) {
  return [...models].sort(
    (a, b) => (Number(a.position) || 0) - (Number(b.position) || 0),
  );
}

function modelCategorySlug(m) {
  return normalizeRowAdApiCategory(m.category) || norm(m.category);
}

/**
 * Escolhe o modelo de row ad visível para o filtro atual.
 * - EPG Desportos (`isSports`): apenas `category === sports` (ignora filtro de categoria da UI).
 * - Live — "Todos": `all` se existir; senão `every_categories`.
 * - Live — outras categorias: match da `category` da API (normalizada); senão `every_categories`.
 * - `Recents`: não exibir (retorna null — o chamador também pode bloquear antes).
 *
 * @param {object[]} models modelos já mapeados (com `category` e `position`)
 * @param {string|undefined} selectedFilterValue `selectedFilter?.value`
 * @param {{ isSports?: boolean }} [options]
 * @returns {object|null}
 */
export function pickEpgRowAdModel(models, selectedFilterValue, options = {}) {
  const { isSports = false } = options;

  if (!Array.isArray(models) || models.length === 0) {
    return null;
  }

  if (selectedFilterValue === EPG_VALUES.recents) {
    return null;
  }

  if (isSports) {
    const sportsMatches = sortByPosition(
      models.filter((m) => modelCategorySlug(m) === ROW_AD_CATEGORY_SPORTS),
    );
    return sportsMatches[0] || null;
  }

  if (isAllFilterTab(selectedFilterValue)) {
    const allMatches = sortByPosition(
      models.filter((m) => modelCategorySlug(m) === ROW_AD_CATEGORY_ALL),
    );
    if (allMatches.length > 0) {
      return allMatches[0];
    }
    const everyMatches = sortByPosition(
      models.filter((m) => modelCategorySlug(m) === ROW_AD_CATEGORY_EVERY),
    );
    return everyMatches[0] || null;
  }

  const wanted = mapEpgFilterValueToRowAdApiCategory(selectedFilterValue);
  if (wanted) {
    const specific = sortByPosition(
      models.filter((m) => modelCategorySlug(m) === wanted),
    );
    if (specific.length > 0) {
      return specific[0];
    }
  }

  const everyMatches = sortByPosition(
    models.filter((m) => modelCategorySlug(m) === ROW_AD_CATEGORY_EVERY),
  );
  return everyMatches[0] || null;
}
